import { api } from '@/lib/api'
import type { BankAccount, CreateBankAccountPayload } from './types'

export const bankAccountsApi = {
  list: () =>
    api.get<{ bank_accounts: BankAccount[] }>('/api/tenant/bank-accounts'),
  recentBanks: () =>
    api.get<{ banks: string[] }>('/api/tenant/bank-accounts/recent-banks'),
  create: (payload: CreateBankAccountPayload) =>
    api.post<{ bank_account: BankAccount }>('/api/tenant/bank-accounts', payload),
}
